"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var queryString = __importStar(require("query-string"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var modal_1 = __importDefault(require("../../../../plugins/modal"));
var fetch_products_by_collection_name_1 = __importDefault(require("../../../../utils/fetch-products-by-collection-name"));
var fetch_birthday_gift_promo_1 = require("../../fetch-birthday-gift-promo");
var utils_1 = require("../../utils");
exports.default = (function () {
    var _a = window.accountApp.settings.birthdayGift, modalImage = _a.modalImage, body = _a.body, addButtonText = _a.addButtonText, declineOfferText = _a.declineOfferText;
    var params = queryString.parse(location.search);
    var birthdayGiftId = params.birthdayGiftId;
    var queryClient = (0, react_query_1.useQueryClient)();
    if (!birthdayGiftId) {
        return null;
    }
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read((0, react_1.useState)(), 2), bundleName = _c[0], setBundleName = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isEligible = _d[0], setIsEligible = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isAddingProduct = _e[0], setIsAddingProduct = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), errorAddingGift = _f[0], setErrorAddingGift = _f[1];
    var _g = __read((0, react_1.useState)([]), 2), variantOffers = _g[0], setVariantOffers = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), successfullyAddedGift = _h[0], setSuccessfullyAddedGift = _h[1];
    var _j = __read((0, react_1.useState)(), 2), selectedVariantOffer = _j[0], setSelectedVariantOffer = _j[1];
    var getBirthdayGiftEligibility = function () { return __awaiter(void 0, void 0, void 0, function () {
        var birthdayGiftResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, fetch_birthday_gift_promo_1.fetchBirthdayGift)(params.birthdayGiftId)];
                case 1:
                    birthdayGiftResponse = _a.sent();
                    if (birthdayGiftResponse === null || birthdayGiftResponse === void 0 ? void 0 : birthdayGiftResponse.isEligible) {
                        setIsEligible(true);
                        setBundleName(birthdayGiftResponse.name);
                    }
                    setIsOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductOffers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var productOffers, eligibleOffers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, fetch_products_by_collection_name_1.default)('birthday-gifts')
                    // used BirthdayOffer mapping to match the correct name to variant
                ];
                case 1:
                    productOffers = _a.sent();
                    eligibleOffers = productOffers.products.reduce(function (acc, curr) {
                        // use the main product name to render the title instead of the variant name
                        var productName = curr.title.split(/\(.+?\)/).join('');
                        var birthdayVariant = curr.variants.find(function (variant) { return variant.option1.includes('Birthday Cake'); });
                        // filter out the variants that are out of stock or unavailable
                        if (birthdayVariant && Number(birthdayVariant.inventory_quantity) > 0) {
                            acc.push({ name: productName, birthdayVariant: birthdayVariant });
                        }
                        return acc;
                    }, []);
                    setVariantOffers(eligibleOffers);
                    setSelectedVariantOffer(eligibleOffers[0].birthdayVariant);
                    return [2 /*return*/];
            }
        });
    }); };
    // Redeem birthday gift through API
    var submitToAPI = function (parameters) { return __awaiter(void 0, void 0, void 0, function () {
        var redeemed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsAddingProduct(true);
                    return [4 /*yield*/, (0, fetch_birthday_gift_promo_1.redeemBirthdayGift)(parameters)];
                case 1:
                    redeemed = _a.sent();
                    if (!(redeemed === null || redeemed === void 0 ? void 0 : redeemed.success)) return [3 /*break*/, 3];
                    // invalidate queries to update the subscriptions in the bundle
                    return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                case 2:
                    // invalidate queries to update the subscriptions in the bundle
                    _a.sent();
                    setSuccessfullyAddedGift(true);
                    return [3 /*break*/, 4];
                case 3:
                    setErrorAddingGift(true);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // smile container keeps popping up because it loads after component has mounted
        // ignoring dependencies for useEffect here as a work-around
        (0, utils_1.hideThirdPartyButtons)();
    });
    (0, react_1.useEffect)(function () {
        getBirthdayGiftEligibility();
    }, []);
    (0, react_1.useEffect)(function () {
        // only bother to fetch product offers if the customer is eligible
        if (isEligible) {
            getProductOffers();
        }
    }, [isEligible]);
    var handleCloseModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // this is async to force window state push to await modal close
                return [4 /*yield*/, setIsOpen(false)];
                case 1:
                    // this is async to force window state push to await modal close
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var birthdayGiftOffers = variantOffers.map(function (variantOffer, i) {
        var _a;
        return (react_1.default.createElement("div", { key: 'product' + i, className: (0, classnames_1.default)('bordered grid-x padding-vertical-2 margin-vertical-3 birthday-gift__radio', variantOffer.birthdayVariant.id === (selectedVariantOffer === null || selectedVariantOffer === void 0 ? void 0 : selectedVariantOffer.id) ? 'bg-selected-wisteria border-wisteria' : ''), style: { borderRadius: '5px' } },
            react_1.default.createElement("div", { className: 'small-1 padding-left-2', style: { margin: 'auto' } },
                react_1.default.createElement("input", { type: 'radio', checked: variantOffer.birthdayVariant.id === (selectedVariantOffer === null || selectedVariantOffer === void 0 ? void 0 : selectedVariantOffer.id), id: 'radioButton' + "".concat(variantOffer.birthdayVariant.id), onChange: function () {
                        setSelectedVariantOffer(variantOffer.birthdayVariant);
                    } })),
            react_1.default.createElement("div", { className: 'small-11 text-left' },
                react_1.default.createElement("label", { defaultChecked: true, htmlFor: 'radioButton' + "".concat(variantOffer.birthdayVariant.id) },
                    react_1.default.createElement("span", { className: 'grid-x' },
                        react_1.default.createElement("span", { className: 'small-9', style: { margin: 'auto', lineHeight: '20px', fontSize: '15px', paddingLeft: '5px' } },
                            "Birthday Bash ",
                            variantOffer.name),
                        react_1.default.createElement("span", { className: 'small-2' },
                            react_1.default.createElement("img", { src: (_a = variantOffer.birthdayVariant.featured_image) === null || _a === void 0 ? void 0 : _a.src })))))));
    });
    return (react_1.default.createElement(modal_1.default, { isOpen: isOpen && variantOffers.length > 0, handleClose: handleCloseModal, closeClassNames: 'ss-delete text-black', style: { overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } } },
        isEligible && (react_1.default.createElement("div", { className: 'padding-5 bg-white text-center', style: { maxWidth: 500 } },
            react_1.default.createElement("div", { className: 'text-center' },
                "Happy Birthday ",
                bundleName,
                "!"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("img", { src: modalImage })),
            react_1.default.createElement("div", { className: 'h5 font-bold padding-bottom-5', style: { fontSize: '19px' } },
                errorAddingGift && react_1.default.createElement("div", { className: 'padding-horizontal-10 text-sea-pink' }, "There was an error adding your gift. Please refresh and try again..."),
                successfullyAddedGift && react_1.default.createElement("div", null,
                    "A FREE gift has been added to ",
                    bundleName,
                    "\u2019s bundle. It will ship with your next bundle"),
                !successfullyAddedGift && !errorAddingGift && body),
            !successfullyAddedGift && !errorAddingGift && birthdayGiftOffers,
            react_1.default.createElement("div", null, !successfullyAddedGift && !errorAddingGift && (react_1.default.createElement("div", null,
                react_1.default.createElement("button", { disabled: isAddingProduct, className: (0, classnames_1.default)('padding-5 text-white width-100', isAddingProduct ? 'bg-light-wisteria text-white cursor-disabled' : 'bg-wisteria text-white'), style: { fontSize: '16px' }, onClick: function () { return submitToAPI({ birthdayGiftId: Number(birthdayGiftId), variantId: Number(selectedVariantOffer === null || selectedVariantOffer === void 0 ? void 0 : selectedVariantOffer.id) }); } }, isAddingProduct && variantOffers.length > 0 ? 'Adding gift to your bundle...' : addButtonText),
                react_1.default.createElement("button", { className: 'button white text-uppercase padding-vertical-5', style: { fontSize: '9px' }, onClick: handleCloseModal },
                    react_1.default.createElement("span", { className: 'bordered border-light-wisteria', style: { borderWidth: '0 0 1px', paddingBottom: '4px' } }, declineOfferText))))))),
        !isEligible && !successfullyAddedGift && react_1.default.createElement("div", { className: 'padding-10' }, "Sorry, you don't qualify for this offer")));
});
